import { create } from 'zustand'

export const useDownloadFileStore = create((set) => ({
    id: "",
    progress: 0,
    setId: (id: string) => set((state) => ({ ...state, id: id })),
    setProgress: (progress: number) => set((state) => ({ ...state, progress: progress })),
  }))